import { Helmet } from "react-helmet";
import { CheckoutComponentChatAttibutesType } from "../../types/builder";

const Crisp: React.FC<
  Pick<CheckoutComponentChatAttibutesType, "accountId">
> = ({ accountId }) => {
  const script = `
    window.$crisp=[];window.CRISP_WEBSITE_ID="${accountId}";(function(){d=document;s=d.createElement("script");s.src="https://client.crisp.chat/l.js";s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})();
  `;

  return (
    <Helmet>
      <script type="text/javascript">{script}</script>
    </Helmet>
  );
};

export default Crisp;
